import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { useTheme } from '../hooks/useTheme'

interface Props {
  transparent?: boolean
}

export default function LandingHeader({ transparent = false }: Props) {
  const { isSignedIn } = useAuth()
  const { theme, toggle } = useTheme()
  const { pathname } = useLocation()

  const isHome = pathname === '/'

  const scrollTo = (id: string) => {
    if (!isHome) {
      window.location.href = `/#${id}`
      return
    }
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <header
      className={`sticky top-0 z-50 border-b transition-colors ${
        transparent ? 'border-transparent bg-transparent' : 'border-ica-border bg-ica-bg/80 backdrop-blur-md'
      }`}
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3">
        <Link to="/" className="text-sm font-semibold tracking-tight">
          Invoice Chase
        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          <button
            onClick={() => scrollTo('problem')}
            className="rounded-lg px-3 py-1.5 text-sm font-medium text-ica-text-secondary transition-colors hover:text-ica-text"
          >
            Product
          </button>
          <button
            onClick={() => scrollTo('how-it-works')}
            className="rounded-lg px-3 py-1.5 text-sm font-medium text-ica-text-secondary transition-colors hover:text-ica-text"
          >
            How it works
          </button>
          <button
            onClick={() => scrollTo('pricing')}
            className="rounded-lg px-3 py-1.5 text-sm font-medium text-ica-text-secondary transition-colors hover:text-ica-text"
          >
            Pricing
          </button>
        </nav>

        <div className="flex items-center gap-2">
          <button
            onClick={toggle}
            className="rounded-lg p-1.5 text-ica-text-muted transition-colors hover:bg-ica-elevated hover:text-ica-text"
            aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
          >
            {theme === 'dark' ? (
              <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
              </svg>
            ) : (
              <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
              </svg>
            )}
          </button>

          {isSignedIn ? (
            <Link
              to="/dashboard"
              className="rounded-lg bg-ica-accent px-4 py-1.5 text-sm font-semibold text-ica-accent-text transition-opacity hover:opacity-90"
            >
              Dashboard
            </Link>
          ) : (
            <Link
              to="/sign-in"
              className="rounded-lg px-4 py-1.5 text-sm font-medium text-ica-text-secondary transition-colors hover:text-ica-text"
            >
              Login
            </Link>
          )}
        </div>
      </div>
    </header>
  )
}
